// $ (document).globalLoader (true); - для включения
// $ (document).globalLoader (false); - для отключения

(function () {
    $ (function () {
        $.fn.extend ({
            globalLoader: (show = true) => {
                if (show) {
                    const loaderHtml =
                        `<div class="global-loader js-global-loader">
                            <div class="i-loader _show">
                                <div class="i-loader__circle">
                                    <div class="i-loader__circle-left"></div>
                                    <div class="i-loader__circle-right"></div>
                                </div>
                            </div>
                        </div>`;
                    $ (loaderHtml).appendTo ($ ('body'));
                    disableBodyScroll (true);
                    $ ('html, body').addClass ('_global-overflow-hidden');
                } else {
                    $ ('.js-global-loader').remove ();
                    disableBodyScroll (false);
                    $ ('html, body').removeClass ('_global-overflow-hidden');
                }
            }
        });
    })
} ());
